<template>
  <mdc-dialog v-model="isOpen"
              class="mdc_dialog_wider"
              :title="'report.chart_for_stimul_daily' | trans"
              :accept="'user.close' | trans"
              @cancel="close"
              @accept="close">

    <loader class="table-loader" v-if="!mandDataSet"></loader>

    <bar-chart :bardatasets="fetchBarDatasetForChart()" :withLabels="true" v-if="mandDataSet"
               :scaleLabelY="'report.reaction_count' | trans"
               :scaleLabelX="'report.blocks' | trans"
               :aspectRatio="false"
               :vertical-line-point="verticalLinePoint"
               v-bind:show-legend="!!mandDataSet.data.length" :height="360"/>

    <h4 class="chart__title mb-3">
      {{graphTitle}}: {{stimulName}}. {{typeTitle}}. ({{toLocaleDate(dataPoint)}})
      <br>
      <span  v-if="mandType == 3  || mandType == 7 || mandType == 8">
        {{ 'report.legend' | trans }}
        {{mandAnswers[0].title}} - {{mandAnswers[0].description}},
        {{mandAnswers[1].title}} - {{mandAnswers[1].description}},
        {{mandAnswers[4].title}} - {{mandAnswers[4].description}}.
      </span>
      <span  v-if="mandType == 9  || mandType == 10">
        {{ 'report.legend' | trans }}
        {{mandAnswers[2].title}} - {{mandAnswers[2].description}}
      </span>
    </h4>

  </mdc-dialog>
</template>

<script>

  import Loader from '../../loader/components/Loader';
  import lang from '../../../lang/translator';
  import axios from 'axios';
  import forEach from 'lodash/forEach';
  import moment from 'moment';

  import {
    BarChart,
    BarChartDataset,
  } from '../../../common/chart';

  export default {
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'stimulName': {
        type: String,
        default() {
          return '';
        },
      },
      'mandType': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'dataPoint': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'stageId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'mandId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'typeTitle': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'graphTitle': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'mandAnswers': null
    },
    data() {
      return {
        verticalLinePoint: [],
        apiUrl: '/protocols/assigned/mand/',
        mandDataSet: null,
      };
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
    },
    components: {Loader, BarChart},
    mounted() {
      this.showMandChart();
    },
    methods: {
      close() {
        this.$emit('close');
      },

      toLocaleDate: function (date) {
        return moment(date*1000).format('DD.MM.YYYY')
      },

      async showMandChart() {
        let url = this.apiUrl + this.protocolId + '/detailed-session-mensuration/'+ this.mandId;
        let response = await axios.get(url, {
          params: {
            date: this.dataPoint,
            stageId: this.stageId,
            type: this.mandType
          }
        });
        this.mandDataSet = response.data.data;
      },

      getRandomColor(i) {

        let letter = i * 48 < 248 ? i * 40 : i * 24;
        let color = 'rgb('+letter+','+letter+','+letter+')' ;

        return color;
      },

      fetchBarDatasetForChart() {
        let data = [];
        let datasets = [];
        let i = 0;
        let label = '';
        let labels = [];
        let backgroundColor = null;

        if(this.mandDataSet.data.length){
          forEach(this.mandDataSet.data, (item,index) => {

            data = item.answers;
            label = item.info.label;
            labels = this.mandDataSet.labels;
            backgroundColor = this.getRandomColor(index);
            datasets.push(new BarChartDataset({
              data, label, labels, backgroundColor
            }));

          });

          this.verticalLinePoint= this.mandDataSet.changes;
        } else{
          data = [];
          label = '';
          labels = [];
          backgroundColor = this.getRandomColor(1);
          datasets.push(new BarChartDataset({
            data, label, labels, backgroundColor
          }));

        }

        console.info(datasets)

        return datasets;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dashboardParent/components/MandPopup.vue